import { app } from '../../../../../app';
import { Controller } from './create-shared-folder.controller';

app.component('companySharingCenterSharedFoldersCreate', {
    bindings: {
        companyId: '<',
        sharedFolders: '='
    },
    controller: Controller,
    templateUrl: require('./create-shared-folder.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/create/create-shared-folder.component..js